import { gsap } from "gsap";

export default class Pajolos {
    constructor() {
        this.heart = document.querySelector('.heart');
        this.heartOutline = document.querySelector('.heart-outline');
        this.eye = document.querySelector('.eye');

        if (this.heart && this.heartOutline) {
            this.animateHeart();
        }

        if (this.eye) {
            this.animateEye();
        }
    }

    animateHeart() {
        const heartOutline = this.heartOutline;
        const connectionGroup = [
            document.querySelector('.heart-to-chest-top'),
            document.querySelector('.heart-to-chest-bottom')
        ];

        const heartTl = gsap.timeline({ repeat: -1, repeatDelay: 0.8 });
        heartTl
            .to(this.heart, {
                scale: 1.1,
                transformOrigin: "center center",
                duration: 0.18,
                ease: "power1.inOut"
            })
            .to(this.heart, {
                scale: 1,
                duration: 0.18,
                ease: "power1.inOut"
            })
            .to(this.heart, {
                scale: 1.05,
                duration: 0.15,
                ease: "power1.inOut"
            })
            .to(this.heart, {
                scale: 1,
                duration: 0.15,
                ease: "power1.inOut"
            });

        const outlineTl = gsap.timeline({ repeat: -1, repeatDelay: 0.8 });
        outlineTl
            .to(heartOutline, {
                scale: 1.15,
                transformOrigin: "center center",
                duration: 0.2,
                ease: "power1.out"
            })
            .to(connectionGroup, {
                scale: 1 / 1.15,
                transformOrigin: "center center",
                duration: 0.2,
                ease: "power1.out"
            }, "<")
            .to(heartOutline, {
                scale: 1,
                duration: 0.2,
                ease: "power1.in"
            })
            .to(connectionGroup, {
                scale: 1,
                transformOrigin: "center center",
                duration: 0.2,
                ease: "power1.in"
            }, "<")

            .to(heartOutline, {
                scale: 1.08,
                duration: 0.15,
                ease: "power1.out"
            })
            .to(connectionGroup, {
                scale: 1 / 1.08,
                transformOrigin: "center center",
                duration: 0.15,
                ease: "power1.out"
            }, "<")
            .to(heartOutline, {
                scale: 1,
                duration: 0.15,
                ease: "power1.in"
            })
            .to(connectionGroup, {
                scale: 1,
                transformOrigin: "center center",
                duration: 0.15,
                ease: "power1.in"
            }, "<");
    }

    animateEye() {
        const pupil = document.querySelector('.eye-pupil');
        const eyeLimit = document.querySelector('.eye-limit');
        const wrapper = document.querySelector('.block-listing.block-listing-a2w-1');

        if (!pupil || !eyeLimit || !wrapper) return;

        // Coordonnées du centre de eye-limit (selon ton SVG)
        const cx = 93.9176;
        const cy = 86.2294;
        const maxRadius = 13; // limite pour que la pupille ne sorte pas du cercle

        wrapper.addEventListener("mousemove", (e) => {
            const rect = wrapper.getBoundingClientRect();

            // Position relative de la souris dans la section
            const mouseX = e.clientX - rect.left;
            const mouseY = e.clientY - rect.top;

            // Position du SVG dans le wrapper
            const svg = pupil.closest('svg');
            const svgRect = svg.getBoundingClientRect();
            const svgX = svgRect.left - rect.left;
            const svgY = svgRect.top - rect.top;

            // Position relative de la souris dans le SVG
            const localX = mouseX - svgX;
            const localY = mouseY - svgY;

            // Vecteur direction entre souris et centre de l’œil
            let dx = localX - cx;
            let dy = localY - cy;
            const distance = Math.sqrt(dx * dx + dy * dy);

            // Normalisation si la souris sort du rayon
            if (distance > maxRadius) {
                const ratio = maxRadius / distance;
                dx *= ratio;
                dy *= ratio;
            }

            gsap.to(pupil, {
                x: dx,
                y: dy,
                duration: 0.3,
                ease: "power2.out"
            });
        });

        wrapper.addEventListener("mouseleave", () => {
            gsap.to(pupil, {
                x: 0,
                y: 0,
                duration: 0.4,
                ease: "power2.out"
            });
        });
    }


}
